
// Этот файл остается для обратной совместимости, но рекомендуется использовать
// новые модульные импорты из src/utils/supabase/courier/index.ts

// Переэкспорт всех функций из новых модулей
export * from './index';

// Уведомление в консоли
console.warn(
  'Внимание: Файл courierQueries.ts устарел. ' +
  'Пожалуйста, используйте импорты из src/utils/supabase/courier/index.ts'
);
